


import React from 'react';
import { useLang } from "../../contexts/LanguageContext";
import { Card, Row, Col } from 'react-bootstrap';

import android_image  from '../../images/android_image.svg';
import web_image  from '../../images/web_image.svg';
import TV_image  from '../../images/tv_image.svg';





const Devices = () => {
  /* Inciar constante de traducción */
  const { t } = useLang();
  
  return (
    <div className="container my-4">
      <h2 className="mb-4">{t("DEVICES_TITLE")}</h2>
      <Row xs={1} md={3} lg={3} className="g-4">

          <Col key='1'>
            <Card className="h-100 shadow-sm">
              <Card.Body className='text-center'>
                <Card.Title><img src={android_image} width={50}px alt={t("DEVICES_GOOGLE_PLAY_TITLE")}></img> {t("DEVICES_GOOGLE_PLAY_TITLE")}</Card.Title>
                <Card.Text>{t("DEVICES_GOOGLE_PLAY_DESC")}</Card.Text>
              </Card.Body>
            </Card>
          </Col>

          <Col key='2'>
            <Card className="h-100 shadow-sm">
              <Card.Body className='text-center'>
                <Card.Title><img src={web_image} width={50}px alt={t("DEVICES_WEB_TITLE")}></img> {t("DEVICES_WEB_TITLE")}</Card.Title>
                <Card.Text>{t("DEVICES_WEB_DESC")}</Card.Text>
              </Card.Body>
            </Card>
          </Col>

          <Col key='13'>
            <Card className="h-100 shadow-sm">
              <Card.Body className='text-center'>
                <Card.Title><img src={TV_image} width={50}px alt={t("DEVICES_ANDROID_TV_TITLE")}></img> {t("DEVICES_ANDROID_TV_TITLE")}</Card.Title>
                <Card.Text>{t("DEVICES_ANDROID_TV_DESC")}</Card.Text>
              </Card.Body>
            </Card>
          </Col>
          


      </Row>
    </div>
  );
};

export default Devices;
